import UnderConstruction from "../UnderConstruction/UnderConstruction";
import styles from "./orderOnline.module.css";

const OrderOnline = () => {
    return (
        <UnderConstruction containerClassName={styles.orderOnlineContainer} />
    );
}

export default OrderOnline;
